import { Component } from '@angular/core';

@Component({
    selector: 'imprint',
    templateUrl: './imprint.component.html'
})
export class ImprintComponent {
}



// WEBPACK FOOTER //
// ./src/app/components/imprint/imprint.component.ts